  (function() {
    const root = document.getElementById('arqeConfigurator');
    if (!root) return;

    const isEnglish =
  document.documentElement.lang &&
  document.documentElement.lang.startsWith('en');

const t = isEnglish ? {

  center: 'Center',
  left: 'Left',
  right: 'Right',
  top: 'Top',
  bottom: 'Bottom',

  switch: 'Switch',
  doubleSwitch: 'Double switch / Blind',
  socket: 'Socket',
  blind: 'Blank',

  toneInTone: 'Tone-on-tone',

  setupSaved: '✓ Setup saved',
  setupSavedSuccess: 'Setup successfully saved',

  editLoaded: 'Configuration loaded for editing.',

  addFirstSetup: 'Please add a setup first.',
  addFirstConfig: 'Please create at least one configuration first.',

  preorder: 'Order now',
  addSetupFirst: 'Add a setup first',

  savedSetups: 'Saved setups',
  totalPins: 'Total toggles',
  subtotal: 'Subtotal',

  orientation: 'Orientation',
  horizontal: 'Horizontal',
  vertical: 'Vertical',

  frameColor: 'Frame finish',
  configuration: 'Configuration',
  contents: 'Included',
  toggle: 'Toggle',

  yourSet: 'Your set',
  baseplateFrame: 'Base plate + frame',
  toggles: 'Toggles',

  noConfigs: 'No additional configuration saved yet.',

  remove: 'Remove',
  edit: 'Edit',

  roomNone: 'No room',
  successfullyAdded: 'Successfully added.',

} : {

  center: 'Mitte',
  left: 'Links',
  right: 'Rechts',
  top: 'Oben',
  bottom: 'Unten',

  switch: 'Schalter',
  doubleSwitch: 'Doppelschalter / Jalousie',
  socket: 'Steckdose',
  blind: 'Blind',

  toneInTone: 'Ton-in-Ton',

  setupSaved: '✓ Setup gespeichert',
  setupSavedSuccess: 'Setup erfolgreich gespeichert',

  editLoaded: 'Konfiguration zum Bearbeiten geladen.',

  addFirstSetup: 'Füge zuerst ein Setup hinzu',
  addFirstConfig: 'Bitte zuerst mindestens eine Konfiguration anlegen.',

  preorder: 'Jetzt bestellen',
  addSetupFirst: 'Füge zuerst ein Setup hinzu',

  savedSetups: 'Gespeicherte Setups',
  totalPins: 'Pins gesamt',
  subtotal: 'Zwischensumme',

  orientation: 'Ausrichtung',
  horizontal: 'Horizontal',
  vertical: 'Vertikal',

  frameColor: 'Rahmenfarbe',
  configuration: 'Belegung',
  contents: 'Lieferumfang',
  toggle: 'Toggle',

  yourSet: 'Dein Set',
  baseplateFrame: 'Basisplatte + Frame',
  toggles: 'Pins',

  noConfigs: 'Noch keine zusätzliche Konfiguration gespeichert.',

  remove: 'Entfernen',
  edit: 'Bearbeiten',

  roomNone: 'Ohne Raum',
  successfullyAdded: 'Erfolgreich hinzugefügt.'
};

    const ARQE_VARIANTS = {
      baseplate: {
        1: 53699923312981,
        2: 53699923345749,
        3: 53699923378517
      },
      
frame: {
  1: {
    Kalk: 55585438499157,
    Moos: 55585438531925,
    Indigo: 55585438466389,
    Ziegel: 55585438564693,
    Sand: 55585438400853,
    Kohle: 55585438368085,
    Torf: 55585438433621
  },
  2: {
    Kalk: 55585438728533,
    Moos: 55585438761301,
    Indigo: 55585438695765,
    Ziegel: 55585438794069,
    Sand: 55585438630229,
    Kohle: 55585438597461,
    Torf: 55585438662997
  },
  3: {
    Kalk: 55585438957909,
    Moos: 55585438990677,
    Indigo: 55585438925141,
    Ziegel: 55585439023445,
    Sand: 55585438859605,
    Kohle: 55585438826837,
    Torf: 55585438892373
  },
  4: {
    Kalk: 55585439187285,
    Moos: 55585439220053,
    Indigo: 55585439154517,
    Ziegel: 55585439252821,
    Sand: 55585439088981,
    Kohle: 55585439056213,
    Torf: 55585439121749
  }
},

      pin: {
        'Kalk': 53707309318485,
        'Moos': 53707533287765,
        'Indigo': 53707533418837,
        'Ziegel': 53707533386069,
        'Sand': 53707533353301,
        'Kohle': 53706446012757,
        'Torf': 53707533320533
      }
    };

    
const pricing = {
  baseplate: { 1: 5, 2: 6, 3: 8 },
  frame: { 1: 17, 2: 24, 3: 31 },
  pin: 2
};


    const colorMap = {
  'Kalk': '#d9d4ca',
  'Moos': '#57583f',
  'Indigo': '#4d586d',
  'Ziegel': '#a96451',
  'Sand': '#d4c2a3',
  'Kohle': '#2b2b29',
  'Torf': '#60524a',

  'Lavendel': '#8072ad',
'Puder': '#d99cb3'
};


const pinColorMap = {
  frame: {
    'Kalk': '#d9d4ca',
    'Moos': '#57583f',
    'Indigo': '#4d586d',
    'Ziegel': '#a96451',
    'Sand': '#d4c2a3',
    'Kohle': '#2b2b29',
    'Torf': '#60524a',

    'Lavendel': '#8072ad',
'Puder': '#d99cb3'
  },

  kohle: '#2b2b29',
  kalk: '#d9d4ca'
};
const pinStyleLabels = {
  frame: t.toneInTone,
  kohle: 'Kohle',
  kalk: 'Kalk'
};

    const countInputs = root.querySelectorAll('input[name="frame_count"]');
    const orientationInputs = root.querySelectorAll('input[name="frame_orientation"]');
const orientationStep = root.querySelector('#orientationStep');
const slotStepTitle = root.querySelector('#slotStepTitle');
const finishStepTitle = root.querySelector('#finishStepTitle');
const pinStepTitle = root.querySelector('#pinStepTitle');
const pinStep = pinStepTitle ? pinStepTitle.closest('.arqe-step') : null;
    const slots = [...root.querySelectorAll('.arqe-slot')];
    const slotSelects = [...root.querySelectorAll('.arqe-slot-select')];
    const previewInner = root.querySelector('#previewInner');
    // Außenrahmenfarbe
const colorSelect = root.querySelector('#arqeColorSelect');

// Frontfarbe
const frontColorSelect = root.querySelector('#arqeFrontColorSelect');

// Toggle-Farbe entspricht immer dem Außenrahmen
const pinStyleSelect = root.querySelector('#arqePinStyleSelect');

function createPinSwatches() {
  if (!pinStyleSelect) return;
  if (root.querySelector('.arqe-pin-swatch-grid')) return;

  var wrap = document.createElement('div');
  wrap.className = 'arqe-swatch-grid arqe-pin-swatch-grid';
  wrap.setAttribute('data-swatch-target', 'arqePinStyleSelect');

  var options = [
    ['kohle', 'Kohle', '#2b2b29'],
    ['kalk', 'Kalk', '#d9d4ca'],
    ['frame', t.toneInTone, colorMap[colorSelect.value] || '#d9d4ca']
  ];

  options.forEach(function(option) {
    var item = document.createElement('span');
    item.className = 'arqe-swatch-button';
    item.setAttribute('data-value', option[0]);

    var swatch = document.createElement('span');
    swatch.className = 'arqe-swatch';

    if (option[0] === 'frame') {
      swatch.className += ' arqe-frame-preview';
    }

    if (option[0] === 'kalk' || option[0] === 'frame') {
      swatch.className += ' arqe-swatch--light';
    }

    swatch.style.backgroundColor = option[2];

    var label = document.createElement('span');
    label.className = 'arqe-swatch-label';
    label.textContent = option[1];

    item.appendChild(swatch);
    item.appendChild(label);

    wrap.appendChild(item);
  });

  pinStyleSelect.parentNode.insertBefore(wrap, pinStyleSelect.nextSibling);
}
function updateSwatches() {
  root.querySelectorAll('.arqe-swatch-grid').forEach(function(grid) {
    var targetId = grid.getAttribute('data-swatch-target');
    var select = root.querySelector('#' + targetId);
    if (!select) return;

    grid.querySelectorAll('.arqe-swatch-button').forEach(function(button) {
      button.classList.toggle('is-active', button.getAttribute('data-value') === select.value);
    });
  });

  var framePreview = root.querySelector('.arqe-frame-preview');
  if (framePreview && colorSelect) {
    framePreview.style.backgroundColor = colorMap[colorSelect.value] || '#d9d4ca';
  }
}
function updatePinStyleOptions() {
  if (!pinStyleSelect) return;

  // DUALTONE: Toggle immer in Außenrahmenfarbe
  pinStyleSelect.value = 'frame';
}
function initSwatchClicks() {
  root.querySelectorAll('.arqe-swatch-grid').forEach(function(grid) {
    var targetId = grid.getAttribute('data-swatch-target');
    var select = root.querySelector('#' + targetId);
    if (!select) return;

    grid.querySelectorAll('.arqe-swatch-button').forEach(function(button) {
      button.addEventListener('click', function() {
  select.value = button.getAttribute('data-value');

  if (targetId === 'arqeColorSelect') {
    updatePinStyleOptions();
  }

  updatePreview();
  updateSwatches();
});
    });
  });
}

const roomSelect = root.querySelector('#arqeRoomSelect');
    const previewFrame = root.querySelector('#previewFrame');
const previewStage = root.querySelector('#previewStage');
const mobileMiniPreview = document.querySelector('#arqeMobileMiniPreview');
const mobileMiniPreviewInner = document.querySelector('#arqeMobileMiniPreviewInner');
if (mobileMiniPreview && mobileMiniPreview.parentElement !== document.body) {
  document.body.appendChild(mobileMiniPreview);
}
    const summary = root.querySelector('#arqeSummary');
    const saveButton = root.querySelector('#arqeSaveConfig');
    const addButton = root.querySelector('#arqeAddToCart') || null;
const addSavedButton = root.querySelector('#arqeAddSavedToCart');
const pdfButton = root.querySelector('#arqeDownloadPdf');
    const status = root.querySelector('#arqeStatus');
const successBox = root.querySelector('#arqeSuccess');
const depthWarning = root.querySelector('#arqeDepthWarning');
    const savedConfigsWrap = root.querySelector('#arqeSavedConfigs');
const savedConfigsSummary = root.querySelector('#arqeSavedConfigsSummary');

const storageKey = 'arqeDualtoneSavedConfigs';
const savedConfigs = JSON.parse(localStorage.getItem(storageKey) || '[]');

function persistSavedConfigs() {
  localStorage.setItem(storageKey, JSON.stringify(savedConfigs));
}
function initMobileStickySaveButton() {
  if (!saveButton) return;

  var headerOffset = 75;
  var originalTop = 0;
  var clone = saveButton.cloneNode(true);

  clone.id = 'arqeSaveConfigSticky';
clone.classList.add('is-sticky-clone');
clone.classList.add('arqe-btn--primary');
clone.textContent = window.innerWidth <= 749
  ? 'Dieses Setup in den Warenkorb'
  : saveButton.textContent;
  if (window.innerWidth <= 749) {
  clone.classList.add('arqe-btn--primary');
}
clone.style.display = 'none';

  document.body.appendChild(clone);

  clone.addEventListener('click', function() {
  saveButton.click();

  setTimeout(function() {
    clone.textContent = 'Dieses Setup in den Warenkorb';
  }, 50);
});

  function measure() {
    var rect = saveButton.getBoundingClientRect();
    originalTop = rect.top + window.scrollY;

    clone.style.left = rect.left + 'px';
    clone.style.width = rect.width + 'px';
  }

  function update() {
    if (window.innerWidth > 749) {
      clone.style.display = 'none';
      root.classList.remove('has-sticky-save');
      return;
    }

    var shouldStick = window.scrollY + headerOffset >= originalTop;

    clone.style.display = shouldStick ? 'block' : 'none';
    root.classList.toggle('has-sticky-save', shouldStick);
  }

  measure();
  update();

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function() {
    measure();
    update();
  });
}

    function getCount() {
      return Number(root.querySelector('input[name="frame_count"]:checked').value);
    }

    function getOrientation() {
      return root.querySelector('input[name="frame_orientation"]:checked').value;
    }

    function getSlotLabel(index, count, orientation) {
      if (orientation === 'horizontal') {
        if (count === 1) return t.center;
        if (count === 2) return index === 0 ? t.left : t.right;
        if (count === 3) return [t.left, t.center, t.right][index];
      } else {
        if (count === 1) return t.center;
        if (count === 2) return index === 0 ? t.top : t.bottom;
        if (count === 3) return [t.top, t.center, t.bottom][index];
      }
      return `Position ${index + 1}`;
    }
    
function createSlotOptionButtons() {
    
  slots.forEach(function(slot) {
    const select = slot.querySelector('.arqe-slot-select');
    if (!select) return;

    if (slot.querySelector('.arqe-slot-options')) return;

    const wrap = document.createElement('div');
    wrap.className = 'arqe-slot-options';

    [...select.options].forEach(function(option) {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'arqe-slot-option';
      button.setAttribute('data-value', option.value);
      button.textContent = option.value;

      if (option.value === select.value) {
        button.classList.add('is-active');
      }

      button.addEventListener('click', function() {
        select.value = option.value;

        wrap.querySelectorAll('.arqe-slot-option').forEach(function(btn) {
          btn.classList.remove('is-active');
        });

        button.classList.add('is-active');

        updatePreview();
      });

      wrap.appendChild(button);
    });

    slot.appendChild(wrap);
  });
}
    function activeSelections() {
      const count = getCount();
      return slotSelects.slice(0, count).map((select, index) => ({
        position: index + 1,
        value: select.value
      }));
    }

    function pinCountFor(value) {
      if (value === 'Schalter') return 1;
      if (value === 'Doppelschalter / Jalousie') return 2;
      
      return 0;
    }

    function frameCodeFor(value) {
      if (value === 'Schalter') return 'S';
      if (value === 'Doppelschalter / Jalousie') return 'D';
      
      if (value === 'Steckdose') return 'O';
      return 'B';
    }

    function formatCurrency(value) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    }

    function resolvePinColor(pinStyle, frameColor) {
      if (pinStyle === 'kohle') return 'Kohle';
      if (pinStyle === 'kalk') return 'Kalk';
      return frameColor;
    }

    function getPinStyleText(pinStyle, frameColor) {
      if (pinStyle === 'frame') return `${t.toneInTone} (${frameColor})`;
      return pinStyleLabels[pinStyle];
    }

    function configSignature(config) {
  return JSON.stringify({
    roomName: config.roomName || '',
    
    count: config.count,
    orientation: config.orientation,
    color: config.color,
frontColor: config.frontColor,
pinStyle: config.pinStyle,
    entries: config.entries.map(entry => entry.value)
  });
}

    function getPinCss(pinStyle, frameColor) {
      const pinColor = pinStyle === 'frame'
        ? pinColorMap.frame[frameColor]
        : pinColorMap[pinStyle];

      const isLight = pinStyle === 'kalk';
      const highlight = isLight ? 'rgba(255,255,255,0.75)' : 'rgba(255,255,255,0.13)';
      const shadow = isLight ? 'rgba(0,0,0,0.10)' : 'rgba(0,0,0,0.22)';

      return `
        --arqe-pin-bg:${pinColor};
        --arqe-pin-highlight:${highlight};
        --arqe-pin-shadow:${shadow};
      `;
    }

    function previewMarkup(type, pinStyle, frameColor) {
      const pinCss = getPinCss(pinStyle, frameColor);

      function singlePin() {
        return `<div class="arqe-preview__pin" style="${pinCss}"></div>`;
      }

      if (type === 'Schalter') {
  return `
    <div class="arqe-visual-switch" style="${pinCss}">
      ${singlePin()}
    </div>
  `;
}

      if (type === 'Doppelschalter / Jalousie') {
  return `
    <div class="arqe-visual-switch--dual">
      <div class="arqe-visual-switch" style="${pinCss}">
        ${singlePin()}
      </div>
      <div class="arqe-visual-switch" style="${pinCss}">
        ${singlePin()}
      </div>
    </div>
  `;
}

   

      if (type === 'Steckdose') {
        return `<div class="arqe-preview__socket-cutout"></div>`;
      }

      return ``;
    }
function updateDepthWarning() {
  if (!depthWarning) return;

  const count = getCount();
  const entries = activeSelections();

  const hasSocket = entries.some(entry => entry.value === 'Steckdose');

  const hasSwitchType = entries.some(entry =>
    entry.value === 'Schalter' ||
    entry.value === 'Doppelschalter / Jalousie'
  );

  depthWarning.classList.toggle(
    'arqe-hidden',
    !(count >= 2 && hasSocket && hasSwitchType)
  );
}

function updatePinStepVisibility() {
  if (!pinStep) return;

  const hasToggleElement = activeSelections().some(entry =>
    entry.value === 'Schalter' ||
    entry.value === 'Doppelschalter / Jalousie'
  );

  pinStep.classList.toggle('arqe-hidden', !hasToggleElement);
}
    function updateVisibleSlots() {
  const count = getCount();
  const orientation = getOrientation();

  if (orientationStep) {
    orientationStep.classList.toggle('arqe-hidden', count === 1);
  }
if (slotStepTitle) {
  slotStepTitle.textContent = count === 1
  ? `2. ${t.configuration}`
  : `3. ${t.configuration}`;
}
if (finishStepTitle) {
  finishStepTitle.textContent = count === 1
  ? `3. ${t.frameColor}`
  : `4. ${t.frameColor}`;
}

if (pinStepTitle) {
  pinStepTitle.textContent = count === 1
  ? `4. ${t.toggle}`
  : `5. ${t.toggle}`;
}

  slots.forEach((slot, index) => {
    slot.classList.toggle('arqe-hidden', index >= count);

    const title = slot.querySelector('.arqe-slot__title');

    if (title) {
      if (count === 1) {
        title.textContent = '';
        title.classList.add('arqe-hidden');
      } else {
        title.textContent = getSlotLabel(index, count, orientation);
        title.classList.remove('arqe-hidden');
      }
    }
  });
}

    function getCurrentConfig() {
      const count = getCount();
      const orientation = getOrientation();
      const color = colorSelect.value;
const frontColor = frontColorSelect
  ? frontColorSelect.value
  : color;

// Bei DUALTONE entspricht der Toggle immer dem Außenrahmen.
const pinStyle = 'frame';

const roomName = roomSelect ? roomSelect.value : '';
      const resolvedPinColor = resolvePinColor(pinStyle, color);
      const entries = activeSelections();
      const pinCount = entries.reduce((sum, entry) => sum + pinCountFor(entry.value), 0);
      const frameCode = entries.map(entry => frameCodeFor(entry.value)).join('-');
      const setupText = count === 1
  ? entries.map(entry => entry.value).join(' | ')
  : entries.map((entry, i) => `${getSlotLabel(i, count, orientation)}: ${entry.value}`).join(' | ');
      const basePrice = pricing.baseplate[count] + pricing.frame[count];
const pinCost = pinCount * pricing.pin;
const total = basePrice + pinCost;

      return {
        count,
roomName,
        orientation,
        color,
        frontColor,
        pinStyle,
        resolvedPinColor,
        entries,
        pinCount,
        frameCode,
        setupText,
        basePrice,
        pinCost,
        total
      };
    }

    
function setPreviewFrameShape(count, orientation) {
  const stageWidth = previewStage ? previewStage.clientWidth : 320;

  // Tatsächliche ARQE-Rahmenproportionen
  const dimensions = {
    1: { width: 85, height: 85 },
    2: { width: 156, height: 85 },
    3: { width: 228, height: 85 }
  };

  const dimensionsForCount = dimensions[count] || dimensions[1];

  const physicalWidth = orientation === 'vertical' && count > 1
    ? dimensionsForCount.height
    : dimensionsForCount.width;

  const physicalHeight = orientation === 'vertical' && count > 1
    ? dimensionsForCount.width
    : dimensionsForCount.height;

  const maxWidth = Math.min(stageWidth - 16, 360);
  const maxHeight = 320;

  const scale = Math.min(
    maxWidth / physicalWidth,
    maxHeight / physicalHeight
  );

  const width = physicalWidth * scale;
  const height = physicalHeight * scale;

  
previewFrame.style.width = `${width}px`;
previewFrame.style.height = `${height}px`;
previewFrame.style.aspectRatio = 'auto';

// Einheitliche Rahmengeometrie für alle Größen
// Bezogen auf die physische Höhe/Breite von 85 mm


const frameThickness = 4 * scale;
const outerRadius = 10 * scale;
const innerRadius = Math.max(outerRadius - frameThickness, 1.5);



previewFrame.style.setProperty('--arqe-frame-thickness', `${frameThickness}px`);
previewFrame.style.setProperty('--arqe-outer-radius', `${outerRadius}px`);
previewFrame.style.setProperty('--arqe-inner-radius', `${innerRadius}px`);

previewFrame.style.borderRadius = `${outerRadius}px`;

}


function updateMobileMiniPreview() {
  if (!mobileMiniPreview || !mobileMiniPreviewInner) return;

  const {
    count,
    orientation,
    color,
    frontColor,
    entries,
    pinStyle
  } = getCurrentConfig();

  const frameColor = colorMap[color] || '#2b2b29';
  const faceColor = colorMap[frontColor] || '#d9d4ca';

  const miniFrame = mobileMiniPreview.querySelector(
    '.arqe-mobile-mini-preview__frame'
  );

  if (!miniFrame) return;

  // Gleiche physische Proportionen wie die Live-Vorschau
  const dimensions = {
    1: { width: 85, height: 85 },
    2: { width: 156, height: 85 },
    3: { width: 228, height: 85 }
  };

  const physical = dimensions[count] || dimensions[1];

  const isVertical = orientation === 'vertical' && count > 1;

  const physicalWidth = isVertical
    ? physical.height
    : physical.width;

  const physicalHeight = isVertical
    ? physical.width
    : physical.height;

  // Maximale lange Seite innerhalb der schwebenden Vorschau
  const maxLongSide = 72;
  const miniScale = maxLongSide /
    Math.max(physicalWidth, physicalHeight);

  const miniWidth = physicalWidth * miniScale;
  const miniHeight = physicalHeight * miniScale;

  // Identische Rahmengeometrie wie die große Vorschau
  const miniThickness = 4 * miniScale;
  const miniRadius = 10 * miniScale;
  const miniInnerRadius = Math.max(
    miniRadius - miniThickness,
    1
  );

  mobileMiniPreview.style.setProperty(
    '--arqe-frame-color',
    frameColor
  );

  mobileMiniPreview.style.setProperty(
    '--arqe-front-color',
    faceColor
  );

  miniFrame.style.width = `${miniWidth}px`;
  miniFrame.style.height = `${miniHeight}px`;
  miniFrame.style.aspectRatio = 'auto';
  miniFrame.style.position = 'relative';
  miniFrame.style.overflow = 'hidden';
  miniFrame.style.borderRadius = `${miniRadius}px`;

  miniFrame.style.setProperty(
    '--arqe-frame-thickness',
    `${miniThickness}px`
  );

  miniFrame.style.setProperty(
    '--arqe-outer-radius',
    `${miniRadius}px`
  );

  miniFrame.style.setProperty(
    '--arqe-inner-radius',
    `${miniInnerRadius}px`
  );

  // Front innerhalb des Außenrahmens positionieren
  mobileMiniPreviewInner.style.position = 'absolute';
  mobileMiniPreviewInner.style.inset = `${miniThickness}px`;
  mobileMiniPreviewInner.style.width = 'auto';
  mobileMiniPreviewInner.style.height = 'auto';
  mobileMiniPreviewInner.style.padding = '0';
  mobileMiniPreviewInner.style.display = 'grid';
  mobileMiniPreviewInner.style.gap = '0';
  mobileMiniPreviewInner.style.overflow = 'hidden';
  mobileMiniPreviewInner.style.borderRadius =
    `${miniInnerRadius}px`;
  mobileMiniPreviewInner.style.zIndex = '2';

  mobileMiniPreviewInner.style.gridTemplateColumns =
    orientation === 'horizontal' && count > 1
      ? `repeat(${count}, 1fr)`
      : '1fr';

  mobileMiniPreviewInner.style.gridTemplateRows =
    orientation === 'vertical' && count > 1
      ? `repeat(${count}, 1fr)`
      : '1fr';

  mobileMiniPreviewInner.innerHTML = entries
    .map(entry => `
      <div
        class="arqe-preview__cell"
        style="
          background:${faceColor};
          --arqe-front-color:${faceColor};
        "
      >
        ${previewMarkup(entry.value, pinStyle, color)}
      </div>
    `)
    .join('');
}


    function updatePreview() {
updateDepthWarning();

      const { count, orientation, color, frontColor, pinStyle, resolvedPinColor, entries, pinCount, frameCode, setupText, basePrice, pinCost, total } = getCurrentConfig();

      previewFrame.style.setProperty('--arqe-frame-color', colorMap[color] || '#d9d4ca');
      previewFrame.style.setProperty('--arqe-front-color', colorMap[frontColor] || '#d9d4ca');
      
      previewFrame.style.background = 'transparent';
      setPreviewFrameShape(count, orientation);

      if (orientation === 'horizontal') {
        previewInner.style.gridTemplateColumns = count > 1 ? `repeat(${count}, 1fr)` : '1fr';
        previewInner.style.gridTemplateRows = '1fr';
      } else {
        previewInner.style.gridTemplateColumns = '1fr';
        previewInner.style.gridTemplateRows = count > 1 ? `repeat(${count}, 1fr)` : '1fr';
      }

      previewInner.innerHTML = entries
        .map(entry => `<div class="arqe-preview__cell" style="--arqe-front-color:${colorMap[frontColor] || '#d9d4ca'}">${previewMarkup(entry.value, pinStyle, color)}</div>`)
        .join('');
        updateMobileMiniPreview();

      const delivery = `1 × Basisplatte, ${count}-fach<br>1 × DUALTONE Frame, ${count}-fach<br>Außenrahmen: ${color}<br>Front: ${frontColor}<br>${pinCount} × Pin${pinCount > 1 ? 's' : ''}, ${color}`;

      updatePinStepVisibility();
      summary.innerHTML = `
        <div style="margin-bottom:10px;">
          <div style="font-size:12px; letter-spacing:0.08em; text-transform:uppercase; color:#6b6b63;">${t.yourSet}</div>
          <div class="arqe-price-big">${formatCurrency(total)}</div>
          <div style="font-size:13px; color:#6b6b63;">${isEnglish ? 'incl. base plate & frame · toggles added automatically' : 'inkl. Basisplatte & Frame · Pins automatisch ergänzt'}</div>
        </div>
        <div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.baseplateFrame}</span>
  <span>${formatCurrency(basePrice)}</span>
</div>

<div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.toggles} (${pinCount})</span>
  <span>${formatCurrency(pinCost)}</span>
</div>

${count > 1 ? `
<div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.orientation}</span>
  <span>${orientation === 'horizontal' ? t.horizontal : t.vertical}</span>
</div>
` : ''}

<div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.configuration}</span>
  <span>${setupText}</span>
</div>

<div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.frameColor}</span>
  <span>${color}</span>
</div>

${pinCount > 0 ? `
  <div class="arqe-summary__row">
    <span class="arqe-summary__label">${t.toggle}</span>
    <span>${getPinStyleText(pinStyle, color)}</span>
  </div>
` : ''}

<div class="arqe-summary__row">
  <span class="arqe-summary__label">${t.contents}</span>
  <span>${delivery}</span>
</div>
      `;
    }
function roomStyle(roomName) {
  const styles = {
    'Wohnzimmer': { accent: '#c8a86b', bg: '#fffaf0', border: '#eadfca' },
    'Küche': { accent: '#9caf88', bg: '#f7faf2', border: '#dde7d1' },
    'Schlafzimmer': { accent: '#8fa0b8', bg: '#f4f7fb', border: '#d8e0eb' },
    'Bad': { accent: '#8db5b0', bg: '#f3faf9', border: '#d5e8e5' },
    'Flur': { accent: '#b9907a', bg: '#fff7f2', border: '#ead8ce' },
    'Büro': { accent: '#9a8fb8', bg: '#f7f5fb', border: '#ded8eb' },
    'Kinderzimmer': { accent: '#d6b36a', bg: '#fff9e8', border: '#eadfbd' },
    'Außenbereich': { accent: '#8f9b7a', bg: '#f7f9f2', border: '#dce3cf' },
    'Ohne Raum': { accent: '#b8b1a5', bg: '#fcfbf8', border: '#dfddd6' }
  };

  return styles[roomName] || styles['Ohne Raum'];
}
    function renderSavedConfigs() {
if (addSavedButton) {
  addSavedButton.disabled = !savedConfigs.length;
  addSavedButton.textContent = savedConfigs.length
    ? t.preorder
: t.addSetupFirst;
}

if (pdfButton) {
  pdfButton.parentElement.style.display = savedConfigs.length ? 'block' : 'none';
}

      if (!savedConfigs.length) {
        savedConfigsWrap.innerHTML = `<div class="arqe-note">${t.noConfigs}</div>`;
        savedConfigsSummary.innerHTML = '';
        return;
      }

      const groupedConfigs = savedConfigs.reduce((groups, config, index) => {
  const room = config.roomName || 'Ohne Raum';
  if (!groups[room]) groups[room] = [];
  groups[room].push({ config, index });
  return groups;
}, {});

savedConfigsWrap.innerHTML = Object.entries(groupedConfigs).map(([room, items]) => {
  const roomTotal = items.reduce((sum, item) => sum + (item.config.total * (item.config.quantity || 1)), 0);

  const style = roomStyle(room);

return `
  <div class="arqe-room-group" style="--room-accent:${style.accent}; --room-bg:${style.bg}; --room-border:${style.border};">
      <div class="arqe-room-group__title">
        ${room}
        <span class="arqe-room-group__meta">${items.length} Setup${items.length > 1 ? 's' : ''} · ${formatCurrency(roomTotal)}</span>
      </div>

      ${items.map(({ config, index }) => {
        const cells = config.entries
  .map(entry => `
    <div class="arqe-preview__cell"
         style="--arqe-front-color:${colorMap[config.frontColor || config.color] || '#d9d4ca'}">
      ${previewMarkup(entry.value, 'frame', config.color)}
    </div>
  `)
  .join('');

        const columns = config.orientation === 'horizontal'
          ? (config.count > 1 ? `repeat(${config.count}, 1fr)` : '1fr')
          : '1fr';

        const rows = config.orientation === 'vertical'
          ? (config.count > 1 ? `repeat(${config.count}, 1fr)` : '1fr')
          : '1fr';

        const qty = config.quantity || 1;
        const pinColor = config.resolvedPinColor || resolvePinColor(config.pinStyle, config.color);

        
const miniLongSide = 112;

const dimensions = {
  1: { width: 85, height: 85 },
  2: { width: 156, height: 85 },
  3: { width: 228, height: 85 }
};

const physical = dimensions[config.count] || dimensions[1];

const physicalWidth =
  config.orientation === 'vertical' && config.count > 1
    ? physical.height
    : physical.width;

const physicalHeight =
  config.orientation === 'vertical' && config.count > 1
    ? physical.width
    : physical.height;

const miniScale = miniLongSide / Math.max(physicalWidth, physicalHeight);

const miniWidth = physicalWidth * miniScale;
const miniHeight = physicalHeight * miniScale;

const miniThickness = 4 * miniScale;
const miniRadius = 10 * miniScale;
const miniInnerRadius = Math.max(miniRadius - miniThickness, 1.5);


        return `
  <div class="arqe-saved-config-card arqe-dualtone">
    <div style="display:flex; justify-content:space-between; gap:16px; align-items:flex-start;">
      <div>
        <div style="font-size:12px; letter-spacing:0.08em; text-transform:uppercase; color:#6b6b63; margin-bottom:6px;">${qty}x Set ${index + 1}</div>
        <div style="font-size:16px; font-weight:600; margin-bottom:4px;">Set ${index + 1}</div>
        <div style="font-size:18px; font-weight:600; margin-bottom:6px;">${formatCurrency(config.total * qty)}</div>
        <div style="font-size:14px; margin-bottom:4px;">
  ${config.count}-fach · ${config.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal'}
</div>
<div style="font-size:13px; color:#6b6b63; margin-bottom:4px;">
  Außenrahmen: ${config.color} · Front: ${config.frontColor || config.color}
</div>
        <div style="font-size:13px; color:#6b6b63; margin-bottom:4px;">Pin: ${getPinStyleText(config.pinStyle, config.color)}</div>
        <div style="font-size:13px; color:#6b6b63; margin-bottom:8px;">${config.setupText}</div>
      </div>

      
<div style="width:112px; height:112px; flex:0 0 112px; display:flex; align-items:center; justify-content:center;">
  <div
    class="arqe-preview__frame arqe-preview__frame--mini arqe-preview__frame--${config.orientation}"
    style="
      position:relative;
      width:${miniWidth}px;
      height:${miniHeight}px;
      padding:0;
      overflow:hidden;
      background:transparent;
      aspect-ratio:auto;
      border-radius:${miniRadius}px;
      --mini-radius:${miniRadius}px;
      --arqe-outer-radius:${miniRadius}px;
      --arqe-inner-radius:${miniInnerRadius}px;
      --arqe-frame-thickness:${miniThickness}px;
      --arqe-frame-color:${colorMap[config.color] || '#d9d4ca'};
      --arqe-front-color:${colorMap[config.frontColor || config.color] || '#d9d4ca'};
    "
  >
    

<div
  class="arqe-preview__frame-skin"
  style="
    position:absolute;
    inset:0;
    width:100%;
    height:100%;
    background:${colorMap[config.color] || '#d9d4ca'};
    border-radius:inherit;
    z-index:0;
  "
></div>

<div
  class="arqe-preview__inner"
  style="
    position:absolute;
    inset:${miniThickness}px;
    width:auto;
    height:auto;
    padding:0;
    display:grid;
    gap:0;
    overflow:hidden;
    border-radius:${miniInnerRadius}px;
    grid-template-columns:${columns};
    grid-template-rows:${rows};
    z-index:2;
  "
>
  ${cells}
</div>

  </div>
</div>


    </div>

    <div class="arqe-config-actions">

      <button
        type="button"
        class="arqe-btn"
        data-edit-config="${index}"
        style="background:#fff; color:#1f1f1c; border:1px solid #dfddd6;"
      >
        ${t.edit}
      </button>

      <button
        type="button"
        class="arqe-btn"
        data-increase-config="${index}"
        style="background:#fff; color:#1f1f1c; border:1px solid #dfddd6;"
      >
        +1
      </button>

      ${qty > 1 ? `
        <button
          type="button"
          class="arqe-btn"
          data-decrease-config="${index}"
          style="background:#fff; color:#1f1f1c; border:1px solid #dfddd6;"
        >
          -1
        </button>
      ` : ''}

      <button
        type="button"
        class="arqe-btn"
        data-remove-config="${index}"
        style="background:#fff; color:#1f1f1c; border:1px solid #dfddd6;"
      >
        ${t.remove}
      </button>

    </div>
  </div>
`;
      }).join('')}
    </div>
  `;
}).join('');

      const totalSets = savedConfigs.reduce((sum, config) => sum + (config.total * (config.quantity || 1)), 0);
      const totalPins = savedConfigs.reduce((sum, config) => sum + (config.pinCount * (config.quantity || 1)), 0);

      savedConfigsSummary.innerHTML = `
  <div class="arqe-summary__row">
    <span class="arqe-summary__label">${t.savedSetups}</span>
    <span>${savedConfigs.length}</span>
  </div>

  <div class="arqe-summary__row">
    <span class="arqe-summary__label">${t.totalPins}</span>
    <span>${totalPins}</span>
  </div>

  <div class="arqe-cart-total">
    <div class="arqe-cart-total__label">${t.subtotal}</div>
    <div class="arqe-cart-total__value">${formatCurrency(totalSets)}</div>
  </div>
`;

      savedConfigsWrap.querySelectorAll('[data-remove-config]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.getAttribute('data-remove-config'));
          savedConfigs.splice(index, 1);
persistSavedConfigs();
renderSavedConfigs();
        });
      });

      savedConfigsWrap.querySelectorAll('[data-increase-config]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.getAttribute('data-increase-config'));
          if (!savedConfigs[index]) return;
          savedConfigs[index].quantity = (savedConfigs[index].quantity || 1) + 1;
persistSavedConfigs();
renderSavedConfigs();
          status.textContent = `Menge für Set ${index + 1} erhöht.`;
        });
      });

      savedConfigsWrap.querySelectorAll('[data-decrease-config]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.getAttribute('data-decrease-config'));
          if (!savedConfigs[index]) return;
          const currentQty = savedConfigs[index].quantity || 1;
          if (currentQty <= 1) {
  savedConfigs.splice(index, 1);
} else {
  savedConfigs[index].quantity = currentQty - 1;
}

persistSavedConfigs();
renderSavedConfigs();
        });
      });

      savedConfigsWrap.querySelectorAll('[data-edit-config]').forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.getAttribute('data-edit-config'));
          const config = savedConfigs[index];
          if (!config) return;

          root.querySelector(`input[name="frame_count"][value="${config.count}"]`).checked = true;
          root.querySelector(`input[name="frame_orientation"][value="${config.orientation}"]`).checked = true;
          // Außenrahmenfarbe wiederherstellen
colorSelect.value = config.color;

// Frontfarbe wiederherstellen
if (frontColorSelect) {
  frontColorSelect.value = config.frontColor || config.color;
}

// Toggle immer in Außenrahmenfarbe
pinStyleSelect.value = 'frame';

if (roomSelect) {
  roomSelect.value = config.roomName || '';
}
          slotSelects.forEach((select, i) => {
            if (config.entries[i]) select.value = config.entries[i].value;
          });
slotSelects.forEach(function(select) {
  const slot = select.closest('.arqe-slot');
  if (!slot) return;

  slot.querySelectorAll('.arqe-slot-option').forEach(function(button) {
    button.classList.toggle(
      'is-active',
      button.getAttribute('data-value') === select.value
    );
  });
});

updatePinStyleOptions();

          savedConfigs.splice(index, 1);
persistSavedConfigs();
updateVisibleSlots();
updatePreview();
updateSwatches();
renderSavedConfigs();
          status.textContent = t.editLoaded;
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function saveCurrentConfig() {
      const config = getCurrentConfig();
      const signature = configSignature(config);
      const existingIndex = savedConfigs.findIndex(saved => configSignature(saved) === signature);

      if (existingIndex !== -1) {
  savedConfigs[existingIndex].quantity = (savedConfigs[existingIndex].quantity || 1) + 1;
  persistSavedConfigs();
  renderSavedConfigs();
  status.textContent = `Menge für Set ${existingIndex + 1} erhöht.`;
  return;
}

      const configToSave = JSON.parse(JSON.stringify(config));
      configToSave.quantity = 1;
      savedConfigs.push(configToSave);
persistSavedConfigs();

if (roomSelect) {
  roomSelect.value = '';
}

renderSavedConfigs();
saveButton.classList.add('arqe-save-success');

setTimeout(() => {
  saveButton.classList.remove('arqe-save-success');
}, 450);
status.textContent = t.setupSaved;
status.style.color = '#4a7c59';
if (successBox) {
  successBox.textContent = t.setupSavedSuccess;
  successBox.classList.remove('arqe-hidden');

  setTimeout(() => {
    successBox.classList.add('arqe-hidden');
  }, 2000);
}

setTimeout(() => {
  const cards = savedConfigsWrap.querySelectorAll('.arqe-saved-config-card');
  const lastCard = cards[cards.length - 1];

  if (lastCard) {
    lastCard.classList.add('arqe-config-added');
  }
}, 50);

setTimeout(() => {
  status.textContent = '';
  status.style.color = '';
}, 2000);

const savedSection = root.querySelector('#arqeSavedConfigsSummary');

if (savedSection) {
  savedSection.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}

    }

    async function addConfiguredSetToCart() {
      const configsToAdd = [...savedConfigs];

      if (!configsToAdd.length) {
        status.textContent = t.addFirstConfig;
        return;
      }

      const items = [];


      if (addButton) addButton.disabled = true;
saveButton.disabled = true;
if (addSavedButton) addSavedButton.disabled = true;
status.textContent = isEnglish
  ? 'Adding all configurations to cart...'
  : 'Alle Konfigurationen werden in den Warenkorb gelegt …';

      try {
        configsToAdd.forEach((config, configIndex) => {
          const nextSetNumber = Number(localStorage.getItem('arqeSetNumber') || '0') + 1;
localStorage.setItem('arqeSetNumber', String(nextSetNumber));

const setLabel = `Set ${nextSetNumber}`;
          const { count, orientation, color, pinStyle, pinCount, frameCode, setupText, total } = config;

const frontColor = config.frontColor || color;
const effectivePinColor = color;
          const qty = config.quantity || 1;

          const baseplateId = ARQE_VARIANTS.baseplate[count];
          const frameId = ARQE_VARIANTS.frame[count] && ARQE_VARIANTS.frame[count][color];
          const pinId = ARQE_VARIANTS.pin[effectivePinColor];

          if (!baseplateId) {
            throw new Error(`Set ${configIndex + 1}: Basisplatten-ID fehlt.`);
          }

          if (!frameId) {
            throw new Error(`Set ${configIndex + 1}: Frame-ID fehlt für ${count}-fach / ${color}.`);
          }

          if (pinCount > 0 && !pinId) {
            throw new Error(`Set ${configIndex + 1}: Pin-ID fehlt für ${effectivePinColor}.`);
          }

          const groupId = 'ARQE-' + Date.now() + '-' + configIndex;

          const commonProps = {
  'Serie': 'ARQE /01 DUALTONE',
  'Setup': `${config.roomName || 'Ohne Raum'} · ${setLabel}`,
  'Konfiguration': `${count}-fach · ${orientation === 'horizontal' ? 'Horizontal' : 'Vertikal'}`,
  'Belegung': setupText,

  'Außenrahmenfarbe': color,
  'Frontfarbe': frontColor,
  'Toggle-Farbe': pinCount > 0 ? color : '-',

  '_ARQE Gruppe': groupId,
  '_ARQE Serie': 'DUALTONE',
  '_ARQE Raum': config.roomName || 'Ohne Raum',
  '_ARQE Set': setLabel,
  '_ARQE Count': String(count),
  '_ARQE Menge': String(qty),
  '_ARQE Belegung': setupText,
  '_ARQE Farbe': color,
  '_ARQE Frontfarbe': frontColor,
  '_ARQE Ausrichtung': orientation,
  '_ARQE Toggle': pinCount > 0 ? color : ''
};

          items.push({
  id: Number(baseplateId),
  quantity: qty,
  properties: {
  ...commonProps,
  'Teil': 'Basisplatte',
  '_ARQE Bestandteil': 'Basisplatte'
}
});

          items.push({
            id: Number(frameId),
            quantity: qty,
            properties: {
  ...commonProps,
  'Teil': 'Frame',
  '_ARQE Bestandteil': 'Frame'
}
          });

          if (pinCount > 0) {
  items.push({
    id: Number(pinId),
    quantity: pinCount * qty,
    properties: {
  ...commonProps,
  'Teil': 'Pin',
  '_ARQE Bestandteil': 'Pin'
}
  });
}
        });


        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });

        const raw = await response.text();
        let data = null;

        try {
          data = JSON.parse(raw);
        } catch (e) {
          data = raw;
        }

        if (!response.ok) {
          console.error('Shopify cart error:', data);
          status.textContent = typeof data === 'object' && data !== null
            ? (data.description || data.message || JSON.stringify(data))
            : raw;
          if (addButton) addButton.disabled = false;
saveButton.disabled = false;
if (addSavedButton) addSavedButton.disabled = false;
          return;
        }

        status.textContent = t.successfullyAdded;
savedConfigs.length = 0;
persistSavedConfigs();
renderSavedConfigs();

if (addButton) addButton.disabled = false;
saveButton.disabled = false;
if (addSavedButton) addSavedButton.disabled = false;

fetch('/?sections=cart-drawer,cart-icon-bubble,header')
  .then(function(res) {
    return res.json();
  })
  .then(function(sections) {
    Object.keys(sections).forEach(function(key) {
      var html = new DOMParser().parseFromString(sections[key], 'text/html');

      ['cart-drawer', '#CartDrawer', '#cart-icon-bubble', 'header-component', '#shopify-section-header'].forEach(function(selector) {
        var fresh = html.querySelector(selector);
        var current = document.querySelector(selector);

        if (fresh && current) {
          current.replaceWith(fresh);
        }
      });
    });

    setTimeout(function() {
  var d=document.querySelector('cart-drawer,dialog,[id*="CartDrawer"]');

  if(d){
    if(typeof d.showModal==='function'&&!d.open){
      d.showModal();
    }

    d.setAttribute('open','');
    d.classList.add('active','open','is-open');
  }
},200);
  });
      } catch (error) {
        console.error('Cart add exception:', error);
        status.textContent = error.message || 'Es gab ein Problem beim Hinzufügen.';
        if (addButton) addButton.disabled = false;
        saveButton.disabled = false;
      }
    }

    countInputs.forEach(input => {
      input.addEventListener('change', () => {
        updateVisibleSlots();
        updatePreview();
      });
    });

    orientationInputs.forEach(input => {
      input.addEventListener('change', () => {
        updateVisibleSlots();
        updatePreview();
      });
    });

    slotSelects.forEach(select => {
  select.addEventListener('change', function() {

    const slot = select.closest('.arqe-slot');
    if (slot) {
      slot.querySelectorAll('.arqe-slot-option').forEach(function(button) {
        button.classList.toggle(
          'is-active',
          button.getAttribute('data-value') === select.value
        );
      });
    }

    updatePreview();
  });
});

    colorSelect.addEventListener('change', function() {
  updatePinStyleOptions();
  updatePreview();
  updateSwatches();
});

pinStyleSelect.addEventListener('change', function() {
  updatePreview();
  updateSwatches();
});
if (frontColorSelect) {
  frontColorSelect.addEventListener('change', function() {
    updatePreview();
    updateSwatches();
  });
}
    saveButton.addEventListener('click', saveCurrentConfig);
    if (addButton) {
  addButton.addEventListener('click', addConfiguredSetToCart);
}
if (addSavedButton) {
  addSavedButton.addEventListener('click', addConfiguredSetToCart);
}

if (pdfButton) {
  pdfButton.addEventListener('click', function(e) {
    e.preventDefault();

    if (!savedConfigs.length) {
      status.textContent = 'Bitte zuerst mindestens ein Setup zur Raumliste hinzufügen.';
      return;
    }

    var totalSets = savedConfigs.reduce(function(sum, config) {
      return sum + (config.total * (config.quantity || 1));
    }, 0);

    var rows = savedConfigs.map(function(config, index) {
  var qty = config.quantity || 1;
  var room = config.roomName || 'Ohne Raum';

  var columns = config.orientation === 'horizontal'
    ? (config.count > 1 ? `repeat(${config.count}, 1fr)` : '1fr')
    : '1fr';

  var rowsGrid = config.orientation === 'vertical'
    ? (config.count > 1 ? `repeat(${config.count}, 1fr)` : '1fr')
    : '1fr';

  var miniLongSide = 62;
  var miniWidth = miniLongSide;
  var miniHeight = miniLongSide;

  if (config.orientation === 'horizontal') {
    miniWidth = miniLongSide;
    miniHeight = miniLongSide / config.count;
  } else {
    miniWidth = miniLongSide / config.count;
    miniHeight = miniLongSide;
  }

  var miniRadius = (38 / 320) * Math.min(miniWidth, miniHeight);

  var cells = config.entries.map(function(entry) {
    return `<div class="pdf-preview-cell">${previewMarkup(entry.value, config.pinStyle, config.color)}</div>`;
  }).join('');

  var preview = `
    <div class="pdf-preview-wrap">
      <div class="pdf-preview-frame" style="width:${miniWidth}px; height:${miniHeight}px; --mini-radius:${miniRadius}px; --arqe-frame-color:${colorMap[config.color] || '#d9d4ca'};">
        <div class="pdf-preview-skin"></div>
        <div class="pdf-preview-inner" style="grid-template-columns:${columns}; grid-template-rows:${rowsGrid};">
          ${cells}
        </div>
      </div>
    </div>
  `;

  return `
    <tr>
      <td>${preview}</td>
      <td>${room}</td>
      <td>${qty}× Set ${index + 1}</td>
      <td>${config.count}-fach</td>
      <td>${config.orientation === 'horizontal' ? 'Horizontal' : 'Vertikal'}</td>
      <td>${config.setupText}</td>
      <td>${config.color}</td>
      <td>${config.pinCount > 0 ? getPinStyleText(config.pinStyle, config.color) : '-'}</td>
      <td>${formatCurrency(config.total * qty)}</td>
    </tr>
  `;
}).join('');

    var printWindow = window.open('', '_blank');

    printWindow.document.write(`
  <!doctype html>
  <html>
    <head>
      <title>ARQE Konfiguration</title>

      <style>

        body {
          font-family: Arial, sans-serif;
          color: #1f1f1c;
          padding: 32px;
          font-size: 12px;
        }

        .pdf-preview-wrap {
          width: 76px;
          height: 76px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pdf-preview-frame {
          position: relative;
          overflow: hidden;
          border-radius: var(--mini-radius);
          background: transparent;
          box-shadow: 0 4px 10px rgba(0,0,0,0.12);
        }

        .pdf-preview-skin {
          position: absolute;
          inset: 0;
          border-radius: inherit;
          background: var(--arqe-frame-color, #d9d4ca);
        }

        .pdf-preview-skin::after {
          content: "";
          position: absolute;
          inset: 1px;
          border-radius: inherit;
          border: 1px solid rgba(30,30,28,0.22);
        }

        .pdf-preview-inner {
          position: relative;
          z-index: 2;
          width: 100%;
          height: 100%;
          display: grid;
        }

        .pdf-preview-cell {
          display: flex;
          align-items: center;
          justify-content: center;
        }
.pdf-preview-cell .arqe-visual-switch,
.pdf-preview-cell .arqe-preview__pin,
.pdf-preview-cell .arqe-preview__socket-cutout {
  position: relative;
  z-index: 2;
}

.pdf-preview-cell .arqe-visual-switch {
  width: 10.588235%;
  height: 18.235294%;
  min-width: 0;
  min-height: 0;
  border-radius: 999px;
  background: var(--arqe-pin-bg, #2b2b29);
  box-shadow:
    inset 0 0 0 1px rgba(30,30,28,0.45),
    inset 0 1px 2px rgba(255,255,255,0.16),
    inset 0 -1px 2px rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-preview-cell .arqe-visual-switch--dual {
  position: relative;
  width: 29.411765%;
  height: 18.235294%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 35%;
  background: transparent;
  box-shadow: none;
}

.pdf-preview-cell .arqe-visual-switch--dual .arqe-visual-switch {
  width: 36%;
  height: 100%;
  flex: 0 0 36%;
}

.pdf-preview-cell .arqe-preview__pin {
  width: 80%;
  aspect-ratio: 1 / 1;
  border-radius: 999px;
  background: var(--arqe-pin-bg, #2b2b29);
  box-shadow:
    inset 0 1px 0 var(--arqe-pin-highlight, rgba(255,255,255,0.18)),
    inset 0 -1px 0 rgba(0,0,0,0.22);
}

.pdf-preview-cell .arqe-preview__pin::before {
  content: "";
  position: absolute;
  inset: 16%;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(255,255,255,0.20), rgba(0,0,0,0.06));
}

.pdf-preview-cell .arqe-preview__socket-cutout {
  width: 45%;
  aspect-ratio: 1 / 1;
  border-radius: 999px;
  background: #fcfbf8;
  box-shadow:
    inset 0 0 0 2px rgba(32,32,30,0.62),
    inset 0 1px 4px rgba(0,0,0,0.12);
}

            h1 {
              font-size: 22px;
              margin: 0 0 6px;
            }

            .subtitle {
              color: #6b6b63;
              margin-bottom: 24px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th {
              text-align: left;
              font-size: 11px;
              text-transform: uppercase;
              letter-spacing: 0.06em;
              color: #6b6b63;
              border-bottom: 1px solid #dfddd6;
              padding: 8px 6px;
            }

            td {
              border-bottom: 1px solid #eee;
              padding: 10px 6px;
              vertical-align: top;
            }

            .total {
              margin-top: 24px;
              font-size: 18px;
              font-weight: 600;
              text-align: right;
            }

            @page {
              margin: 18mm;
            }
          </style>
        </head>
        <body>
          <h1>ARQE /01 Konfiguration</h1>
          <div class="subtitle">Zusammenfassung deiner gespeicherten Setups</div>

          <table>
            <thead>
              <tr>
  <th>Vorschau</th>
  <th>Raum</th>
  <th>Set</th>
                <th>Anzahl</th>
                <th>Ausrichtung</th>
                <th>Belegung</th>
                <th>Rahmenfarbe</th>
                <th>Toggle</th>
                <th>Preis</th>
              </tr>
            </thead>
            <tbody>
              ${rows}
            </tbody>
          </table>

          <div class="total">Zwischensumme: ${formatCurrency(totalSets)}</div>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  });
}

if (mobileMiniPreview && previewStage) {
  const previewObserver = new IntersectionObserver(
    ([entry]) => {
      mobileMiniPreview.classList.toggle(
        'arqe-hidden',
        entry.isIntersecting
      );
    },
    {
      threshold: 0.15
    }
  );

  previewObserver.observe(previewStage);
}

function applyInitialConfig() {
  const path = window.location.pathname;

  let count = 1;

  if (path.includes('arqe-01-set-duo')) {
    count = 2;
  }

  if (path.includes('arqe-01-set-trio')) {
    count = 3;
  }

  const countInput = root.querySelector(`input[name="frame_count"][value="${count}"]`);
  if (countInput) {
    countInput.checked = true;
  }

  slotSelects.forEach(function(select, index) {
  select.value = 'Schalter';
});
}

applyInitialConfig();

    // createPinSwatches();
createSlotOptionButtons();
initSwatchClicks();
initMobileStickySaveButton();
updateVisibleSlots();
updatePinStyleOptions();
updatePreview();
updateMobileMiniPreview();
updateSwatches();
renderSavedConfigs();
status.textContent = '';
  })();